export enum EEnergyViewType {
  UNIT = "UNIT",
  BILL = "BILL",
  ALL = "ALL",
}
